import { useParams } from 'react-router-dom';
import { useSuspenseQuery } from '@tanstack/react-query';
import { faCheck, faXmark } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { fetchAccountPermissionSimulator } from 'api/account';
import * as Drawer from 'components/drawer';
import { useCurrentAccount } from 'customHooks/useCurrentAccount';
import { accountQueryKeys } from 'queries/account-query-keys';

const getSimData = (roleId: string) => {
    const roles = roleId.split(',');
    return {
        roles: roles,
    };
};

const ViewRoleDrawer = () => {
    const { accountId } = useCurrentAccount();
    const { roleId } = useParams<{ roleId: string }>();
    const simulatorData = getSimData(roleId);

    const { data: simulation } = useSuspenseQuery({
        queryKey: accountQueryKeys.accountPermissionSimulator(accountId, simulatorData),
        queryFn: () => fetchAccountPermissionSimulator(accountId, simulatorData),
    });

    return (
        <>
            <Drawer.Header>
                <Drawer.Title>View role permission</Drawer.Title>
                <Drawer.Close />
            </Drawer.Header>
            <Drawer.Body className="flex flex-row gap-6">
                <div className={'flex flex-col justify-between gap-4'}>
                    {simulation.permissions?.map(sectionInfo => {
                        return (
                            <div key={sectionInfo.section_key} className="flex flex-col">
                                <div className="text-md font-bold">
                                    {sectionInfo.section_name} permissions
                                </div>
                                <div>
                                    {sectionInfo.permissions.map(details => {
                                        return (
                                            <div
                                                key={details.key}
                                                className="flex flex-row gap-1 pb-2 pl-4"
                                            >
                                                <div>
                                                    {details.granted ? (
                                                        <FontAwesomeIcon
                                                            icon={faCheck}
                                                            className={'text-green-500'}
                                                        />
                                                    ) : (
                                                        <FontAwesomeIcon
                                                            icon={faXmark}
                                                            className={'text-red-500'}
                                                        />
                                                    )}
                                                </div>
                                                <div className={`flex flex-col`}>
                                                    <div className={`font-semibold`}>
                                                        {details.name}
                                                    </div>
                                                    <div className={`text-sm`}>
                                                        {details.description}
                                                    </div>
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        );
                    })}
                </div>
            </Drawer.Body>
            <Drawer.Footer>
                <div className={'flex w-full flex-wrap-reverse items-center justify-between gap-2'}>
                    <Drawer.Cancel>Close</Drawer.Cancel>
                </div>
            </Drawer.Footer>
        </>
    );
};

export { ViewRoleDrawer };
